import { render } from "./confirmation.vue?vue&type=template&id=5779e437&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"

import "./confirmation.vue?vue&type=style&index=0&id=5779e437&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5779e437"]])

export default __exports__